<template>
  <div v-if="isShown" class="loading overlay">
    <div>
      <img :src="logoLoaderUrl" />
    </div>
    <slot name="extra"></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import logoLoaderUrl from '../assets/img/logo-loader.png';

export default defineComponent({
  name: 'CodementumLoader',
  props: {
    showOnInit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isShown: this.showOnInit as boolean,
      logoLoaderUrl
    };
  },
  mounted() {
    this.$root.$on('CodementumLoader::show', () => {
      this.isShown = true;
    });
    this.$root.$on('CodementumLoader::hide', () => {
      this.isShown = false;
    });
    this.$root.$emit('CodementumLoader::init', this);
  }
});
</script>

<style scoped>
*:has(.loading) {
  isolation: isolate;
}

.loading {
  position: absolute;
  inset: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  background: radial-gradient(circle, #42464e, #282c34);
}

.loading > div {
  color: white;
  text-align: center;
  user-select: none;
}

.loading > div > img {
  width: 4.375rem;
  animation:
    logo-spin-start 0.5s 1s linear forwards,
    logo-spin 3s 2s steps(4, start) infinite;
  animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.4);
}

@keyframes logo-spin-start {
  to {
    transform: rotate(45deg);
  }
}

@keyframes logo-spin {
  0%,
  50%,
  75%,
  100% {
    transform: rotate(45deg);
  }
  25% {
    transform: rotate(225deg);
  }
}
</style>
